import { useChat } from '../../hooks/useChat';

export function ChatHeader() {
  const { minimize } = useChat();

  return (
    <div className="flex items-center gap-3 rounded-t-2xl bg-[#1b312e] px-4 py-3">
      {/* Aria avatar */}
      <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-[#53978e] text-sm font-bold text-white shadow-md">
        A
      </div>

      <div className="flex-1 min-w-0">
        <p className="text-sm font-semibold leading-none text-white">Aria</p>
        <p className="mt-0.5 text-xs text-[#DDECEB]/70">Support Assistant · Online</p>
      </div>

      {/* Minimize */}
      <button
        onClick={minimize}
        aria-label="Minimize chat"
        className="flex h-7 w-7 items-center justify-center rounded-lg text-white/60 transition-colors hover:bg-white/10 hover:text-white"
      >
        <svg className="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2.5}>
          <path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" />
        </svg>
      </button>
    </div>
  );
}
